import React from 'react';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import { setDash } from '../../../../../lib/common';

/**
 *  선택된 브랜드 아이템 리스트와 브랜드 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const { filterOption, onFilter, openImgViewModal } = data;
  return [
    {
      accessor: 'url',
      Header: '이미지',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} openImgViewModal={openImgViewModal} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: !!filterOption,
      fixed: 'left',
      width: 120,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.id} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeTier',
      Header: '브랜드 티어',
      width: 100,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'storeLikeCnt',
      Header: '브랜드 찜 수',
      width: 100,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'onSaleProductCnt',
      Header: '판매중인 상품 수',
      width: 120,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'entryDate',
      Header: '입점일자',
    },
  ];
};
